import { combineReducers } from 'redux';
import hotel from './redux/hotel/hotel.reducer';
import filter from './redux/filter/filter.reducer';
import metadata from './redux/metadata/metadata.reducer';
import user from './redux/user/user.reducer';
import booking from './redux/booking/booking.reducer';
import loyaltyProgram from './redux/loyaltyProgram/loyaltyProgram.reducer';
import analytics from './redux/analytics/analytics.reducer';
import bigpoints from './redux/bigpoints/bigpoints.reducer';
import smartfill from './redux/hotel/smartfill.reducer';
import favourites from './redux/favourites/favourites.reducer';
export default combineReducers({
  hotel,
  filter,
  metadata,
  user,
  booking,
  loyaltyProgram,
  analytics,
  bigpoints,
  smartfill,
  favourites,
});
